import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getChatMessageList, deleteChatMessage } from '../../api/chat';
import { message } from 'antd';

// 获取聊天消息列表
export const fetchChatMessages = createAsyncThunk(
  'chatMessage/fetchChatMessages',
  async (params, { rejectWithValue }) => {
    try {
      const response = await getChatMessageList(params);
      if (response.code === 200) {
        return response.data;
      }
      return rejectWithValue(response.message || '获取聊天消息列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取聊天消息列表失败');
    }
  }
);

// 删除聊天消息
export const removeChatMessage = createAsyncThunk(
  'chatMessage/removeChatMessage',
  async (id, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await deleteChatMessage(id);
      if (response.code === 200) {
        message.success('删除聊天消息成功');
        // 刷新列表，保持当前查询条件
        const { current, pageSize } = getState().chatMessage;
        dispatch(fetchChatMessages({ pageNum: current, pageSize }));
        return id;
      }
      return rejectWithValue(response.message || '删除聊天消息失败');
    } catch (error) {
      return rejectWithValue(error.message || '删除聊天消息失败');
    }
  }
);

const initialState = {
  messages: [],
  total: 0,
  current: 1,
  pageSize: 10,
  loading: false,
  error: null,
  currentMessage: null,
  sessionId: null,
};

const chatMessageSlice = createSlice({
  name: 'chatMessage',
  initialState,
  reducers: {
    setCurrentMessage: (state, action) => {
      state.currentMessage = action.payload;
    },
    clearCurrentMessage: (state) => {
      state.currentMessage = null;
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // 获取聊天消息列表
      .addCase(fetchChatMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChatMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload.records;
        state.total = action.payload.total;
        state.current = action.payload.current;
        state.pageSize = action.payload.size;
      })
      .addCase(fetchChatMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        message.error(action.payload || '获取聊天消息列表失败');
      })
      
      // 删除聊天消息
      .addCase(removeChatMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeChatMessage.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(removeChatMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        message.error(action.payload || '删除聊天消息失败');
      });
  },
});

export const { setCurrentMessage, clearCurrentMessage, setSessionId } = chatMessageSlice.actions;

export default chatMessageSlice.reducer; 